/* tslint:disable */
/* eslint-disable */
export enum InquiryStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
  Pending = 'Pending'
}
